import loader from './loader';

window.morningstar = window.morningstar || {};
window.morningstar.loader = window.morningstar.loader || {};
window.morningstar.loader = Object.assign(window.morningstar.loader, loader);



// WEBPACK FOOTER //
// ./src/index.js